/**
 * Calculates the subtotal while taking into account tax inclusive values
 * Note - this is a temporary workaround due to missing tax info in square check (PXS-80842)
 * @param {Order} order - The Square Order
 * @returns {Check} A Paytronix Check.
 */
export function calculateSubTotal(order) {
  return (
    (order.lineItems ?? []).reduce((accumulator, lineItem) => {
      const itemSubTotal =
        (Number(lineItem.basePriceMoney?.amount) +
          getModifierTotal(lineItem.modifiers ?? [])) *
          Number(lineItem.quantity) -
        Number(lineItem.totalDiscountMoney?.amount);
      return accumulator + itemSubTotal;
    }, 0) / 100
  );
}

function getModifierTotal(modifiers) {
  return modifiers.reduce((accumulator, modifier) => {
    return accumulator + Number(modifier.basePriceMoney?.amount);
  }, 0);
}
